
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prohibited_conduct",
      function () {
        return require("private-next-pages/prohibited_conduct.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prohibited_conduct"])
      });
    }
  